/* esm.sh - @radix-ui/react-visually-hidden@1.2.4 */
export * from "/*@radix-ui/react-visually-hidden@1.2.4/esnext/react-visually-hidden.mjs";
